import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { SplashScene } from "./SplashScene";
import * as Carrom from "carrom-king-engine";
import { AudioManager } from "../../AudioManager";
import { BootScene } from "../BootScene";

export class DifficultySelectionMenu extends Phaser.GameObjects.Container {

    private rulesContainer: Phaser.GameObjects.Container;
    private rulesTitleLabel: Phaser.GameObjects.Text;
    private rulesText: Phaser.GameObjects.Text;
    private rulesButton: Button;
    private beginnerButton: Button;
    private expertButton: Button;
    private rulesBackground: Phaser.GameObjects.Graphics;
    constructor(scene: Phaser.Scene) {

        super(scene);

        this.rulesContainer = new Phaser.GameObjects.Container(this.scene);
        this.rulesContainer.visible = false;
        this.add(this.rulesContainer);

        const width = 720;
        let height = 580;

        this.rulesBackground = new Phaser.GameObjects.Graphics(this.scene);
        this.rulesBackground.y = -30;

        this.rulesBackground.fillStyle(0x000000, .35);
        this.rulesBackground.fillRoundedRect(-width / 2, -height / 2, width, height, 20);
        this.rulesContainer.add(this.rulesBackground);

        const gameText = this.scene.game.cache.json.get("game-text");

        this.rulesTitleLabel = new Phaser.GameObjects.Text(this.scene, 0, -260 + (BootScene.textYgap * -80), gameText.PROFESSIONAL_RULES_TITLE, { fontFamily: "Teko-Medium", fontSize: "80px", color: "#FFFFFF" });
        this.rulesTitleLabel.setOrigin(.5,BootScene.originY);
        this.rulesTitleLabel.setShadow(0, 5, "#061f55", 0, false, true);
        this.rulesContainer.add(this.rulesTitleLabel);

        this.rulesText = new Phaser.GameObjects.Text(this.scene, 0, -200 + (BootScene.textYgap * -224), gameText.FREESTYLE_RULES, { fontFamily: "Montserrat-Black", fontSize: "28px", color: "#FFFFFF" });
        this.rulesText.setOrigin(.5, 0);
        if(BootScene._isBrave){
            this.rulesText.setLineSpacing(20 + (BootScene.textYgap * -350));
        }
        this.rulesContainer.add(this.rulesText);


        this.rulesButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_rules_off", "btn_rules_on");
        this.rulesButton.y = -130;
        this.rulesButton.onDown(this.onDownRules, this);
        this.add(this.rulesButton);

        this.beginnerButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_beginner_off", "btn_beginner_on");
        this.beginnerButton.y = 50;
        this.beginnerButton.onDown(this.onDownBeginner, this);
        this.add(this.beginnerButton);

        this.expertButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_expert_off", "btn_expert_on");
        this.expertButton.y = 185;
        this.expertButton.onDown(this.onDownExpert, this);
        this.add(this.expertButton);

        if (GameVars.gameData.gems < GameConstants.EXPERT_MATCH_FEE) {
            this.expertButton.alpha = .25;
            this.expertButton.disableInteractive();
        }

        const backButton = new Button(this.scene, 0, 325, "texture_atlas_1", "btn_back_off", "btn_back_on");
        backButton.onDown(this.onClickBack, this);
        this.add(backButton);
    }

    public onGameModeSelected(): void {

        const gameText = this.scene.game.cache.json.get("game-text");

        if (GameVars.gameMode === Carrom.GameMode.PROFESSIONAL) {
            this.rulesContainer.y = - 130;
            this.rulesBackground.scaleY = 1.2;
            this.rulesBackground.y = 40;
        } else {
            this.rulesContainer.y = 0;
            this.rulesBackground.scaleY = 1;
            this.rulesBackground.y = -30;
        }

        this.rulesTitleLabel.text = GameVars.gameMode === Carrom.GameMode.PROFESSIONAL ? gameText.PROFESSIONAL_RULES_TITLE : gameText.FREESTYLE_RULES_TITLE;
        this.rulesText.text = GameVars.gameMode === Carrom.GameMode.PROFESSIONAL ? gameText.PROFESSIONAL_RULES : gameText.FREESTYLE_RULES;
    }

    private onDownRules(): void {

        AudioManager.playSound("click_btn");

        this.rulesContainer.visible = true;
        this.rulesButton.visible = false;
        this.beginnerButton.visible = false;
        this.expertButton.visible = false;
    }

    private onDownBeginner(): void {

        AudioManager.playSound("click_btn");

        GameManager.onDifficultySelected(Carrom.Difficulty.BEGINNER);
    }

    private onDownExpert(): void {

        AudioManager.playSound("click_btn");

        GameManager.onDifficultySelected(Carrom.Difficulty.EXPERT);
    }

    private onClickBack(): void {

        this.beginnerButton.visible = true;
        this.expertButton.visible = true;
        this.rulesButton.visible = true;

        if (this.rulesContainer.visible) {

            this.rulesContainer.visible = false;

        } else {

            SplashScene.currentInstance.onBackFromDifficultySelection();
        }

        AudioManager.playSound("click_btn");
    }
}
